function initMobileFlickity() {
  if (window.matchMedia("(max-width: 480px)").matches) {
    const sliderContainer = document.querySelector('.floating-reviews-section__columns');
    if (!sliderContainer) return null;

    // remove only once, mark container
    if (!sliderContainer.dataset.secondRemoved) {
      const secondSlide = sliderContainer.querySelector(':scope > *:nth-child(2)');
      if (secondSlide) {
        secondSlide.remove();
        sliderContainer.dataset.secondRemoved = "true"; // <--- DOM flag
      }
    }

    const flkty = new Flickity(sliderContainer, {
      cellAlign: 'left',
      contain: true,
      wrapAround: true,
      autoPlay: 5000,
      pauseAutoPlayOnHover: false,
      prevNextButtons: false,
      imagesLoaded: true,
      adaptiveHeight: true,
      pageDots: true
    });

    flkty.on('pointerDown', () => {
      flkty.player.play(); // keep it running
    });
    flkty.on('pointerUp', () => {
      flkty.player.play(); // resume instantly
    });
    flkty.on('staticClick', () => {
      flkty.player.play(); // also cover taps without drag
    });

    // prevent jumping on iOS scroll resize
    let resizeTimer;
    window.addEventListener("resize", () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        flkty.resize();
      }, 200);
    });

    return flkty;
  }
  return null;
}

let mobileFlickity = initMobileFlickity();

window.addEventListener('resize', function () {
  if (mobileFlickity && !window.matchMedia("(max-width: 480px)").matches) {
    mobileFlickity.destroy();
    mobileFlickity = null;
  } else if (!mobileFlickity) {
    mobileFlickity = initMobileFlickity();
  }
});
